module.exports = __webpack_public_path__ + "img/vpc-service.5b558e7.svg";